export function Services() {
  return (
    <div className="max-w-4xl">
      <h1 className="text-3xl mb-2">Service Organizations</h1>
      <p className="text-[var(--color-text-secondary)] mb-8">
        Service organizations are stand-alone business entities that provide a reproducible
        product or service. Unlike research applications that support individual projects,
        service organizations represent long-lasting business processes backed by durable
        technology infrastructure.
      </p>

      <div className="grid gap-4">
        <div className="card">
          <h2 className="text-xl mb-2">GEMS Sensing</h2>
          <p className="text-sm text-[var(--color-text-secondary)] mb-4">
            Turnkey IoT sensing solutions for agricultural and environmental research.
            Real-time sensor networks for soil moisture, weather, and field conditions
            deployed across research sites.
          </p>
          <div className="flex gap-3">
            <a
              href="https://gems.umn.edu/services/gems-sensing"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary text-sm no-underline"
            >
              About
            </a>
            <a
              href="https://sensing-0.msi.umn.edu/"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-secondary text-sm no-underline"
            >
              Grafana Dashboard
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
